import "./SocialsMini.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import socialsData from "./SocialsData";

const SocialsMini = () => {
  return (
    <ul className="socialsMini__list">
      {socialsData.map(({name, href, icon}) => (
        <li className="socialsMini__item" key={name}>
          <a href={href} className="socialsMini__link" target="_blank" rel="noopener noreferrer" aria-label={name}>
            <FontAwesomeIcon icon={icon} />
          </a>
        </li>
      ))}
    </ul>
  )
}

export default SocialsMini;